<div vng-dialog-title class="text-center">{{ data?.action === "edit" ? "Edit" : "Add New" }} FlyCut</div>
<vng-dialog-content>
<!-- Issue #521/#541: the walkthrough is a two-step tour, both steps anchored
     over the whole modal — the anchor sits on the FORM itself (not just the
     scrollable fields block below) so it spans the Cancel/Save row too. QA
     F-2 on PR #533: anchoring only the fields block left Save under the
     tour's backdrop and Cancel under the popover card itself, since both
     buttons sat OUTSIDE that narrower anchor's rect. -->
<form class="clearfix hide-lastpass" id="no-lastpass-prefill" [formGroup]="form" vngTourAnchor="modal"
  (ngSubmit)="submitForm()">
  <div class="fix-height add-new-fly-cut-modal" style="display: flex; flex-direction: column">
    <!-- Shared app-category-select owns the searchable vng-select + sticky
         "Create New Category" row; category creation stays here
         (CategoryRenameComponent via shortcutCategoryRename). Issue #521:
         category creation is now allowed during onboarding too (it used to
         be suppressed via [canCreate]="!isOnboarding"). -->
    <app-category-select
      #categorySelect
      label="Category"
      style="margin-bottom: 1.45rem"
      createLabel="Create New Categories"
      [control]="form.controls['category_id']"
      [options]="categoryOptions"
      [canCreate]="true"
      [error]="
        form.controls['category_id'].invalid &&
        (form.controls['category_id'].dirty || form.controls['category_id'].touched) &&
        form.controls['category_id'].hasError('required')
          ? 'You must select a category.'
          : ''
      "
      (createCategory)="shortcutCategoryRename($event ? { name: $event } : {})"
    ></app-category-select>

    <div class="shortcut-fields-row">
      <vng-input
        label="FlyCut"
        placeholder="FlyCut"
        style="flex: 1 1 100%; max-width: 30%"
        type="text"
        autocomplete="new-password"
        data-lpignore="true"
        [formControl]="form.controls['shortcut']"
        [flyMsgIgnore]="true"
        [error]="
          form.controls['shortcut'].dirty || form.controls['shortcut'].touched
            ? form.controls['shortcut'].hasError('required')
              ? 'FlyCut is required'
              : form.controls['shortcut'].hasError('notUnique') ? 'This FlyCut already exists' : ''
            : ''
        "
      ></vng-input>

      <vng-input
        label="Title/Description"
        placeholder="Title/Description"
        style="flex: 1 1 100%; max-width: 70%"
        type="text"
        autocomplete="new-password"
        data-lpignore="true"
        [formControl]="form.controls['title']"
        [flyMsgIgnore]="true"
        [error]="
          (form.controls['title'].dirty || form.controls['title'].touched) &&
          form.controls['title'].hasError('required')
            ? 'Title is required'
            : ''
        "
        info="Your Title/Description is a quick reference reminder of the content inside of the FlyMSG or of your applicable use case. This area is searchable via the search bar in addition to content in your FlyMSG."
      ></vng-input>
    </div>

    <div class="text-title" style="display: flex; justify-content: flex-start; align-items: center; gap: 5px">
      <label for="expanded" class="font-weight-bold">FlyMSG</label>
      <vng-icon
        name="help_center"
        [outline]="false"
        color="purple"
        class="help-icon"
        ngbPopover="The text you create here will automatically replace your FlyCut that you type whenever and wherever you use it."
      >
      </vng-icon>
    </div>
    <editor [apiKey]="editorApiKey" [cloudChannel]="'8'" id="editor" [init]="editorConfig" (onInit)="setEditorManager($event)"
      (keyup)="shortcutErrors = []" *ngIf="editorConfig" [hidden]="!isEditorLoaded" name="html" ngDefaultControl
      [formControl]="form.controls['html']">
    </editor>

    <div *ngFor="let err of shortcutErrors; let i = index">
      <p class="warn-txt" style="margin: 6px 0">
        <img style="vertical-align: bottom" src="../../../assets/images/warning.png" alt="" />
        <span> {{ err }}</span>
      </p>
    </div>
    <div *ngIf="!isEditorLoaded">
      <div class="animated-background editor-toolbar"></div>
      <div class="animated-background editor-body"></div>
    </div>
    <div *ngIf="form.controls['html'].invalid && (form.controls['html'].dirty || form.controls['html'].touched)">
      <small *ngIf="form.controls['html'].hasError('required')" class="warn-txt">You must enter expanded
        text.</small>
    </div>
  </div>

  <!-- Issue #521: Cancel/Save are no longer disabled until the tour's last
       step — that coupling only made sense with the old 4-step walkthrough. -->
  <div class="top-space" style="display: flex; justify-content: center; align-items: center; gap: 15px">
    <button class="add-shortcut-action" type="button" vng-button variant="outline" tabindex="2" (click)="close()">
      Cancel
    </button>
    <button class="add-shortcut-action" type="submit" vng-button variant="primary" tabindex="2">
      Save
    </button>
  </div>
</form>
</vng-dialog-content>